import React from 'react';

export interface ITab {
    tabIndex: number;
    changeTabIndex: (value: number) => void;
    handleTabChange: (e: React.ChangeEvent<{}>, value: number) => void;    
}

export function useTab (initialTabIndex: number = 0) : ITab {
    const [_tabIndex, _setTabIndex] = React.useState(initialTabIndex);

    const changeTabIndex = React.useCallback((value: number) => {
        _setTabIndex(value);
    }, []);

    const handleTabChange = React.useCallback((e: React.ChangeEvent<{}>, value: number) => {
        changeTabIndex(value);
    }, [changeTabIndex]);

    return React.useMemo(() => ({
        tabIndex: _tabIndex, changeTabIndex, handleTabChange
    }), [_tabIndex, changeTabIndex, handleTabChange]);
}